import React from "react";

import {
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import theme from "../../../../constants/theme";
import Container from "../../../../components/Container";
import Button from "../../../../components/Button";
import bookIcon from "../../../../assets/images/card-book-icon.png";
import homeIcon from "../../../../assets/images/card-home-icon.png";
import mobileIcon from "../../../../assets/images/card-mobile-icon.png";
import websiteIcon from "../../../../assets/images/card-website-icon.png";

const useStyles = makeStyles(() =>
  createStyles({
    heading: {
      padding: theme.spacing(0, 0, 10, 0),
      textAlign: "center",
    },
    subheading: {
      paddingBottom: theme.spacing(3),
      fontSize: 18,
    },
    accent: {
      fontWeight: "bold",
      color: theme.palette.primary.main,
    },
    root: {
      textAlign: "center",
      justifyContent: "center",
      padding: theme.spacing(0, 4, 10, 0),
    },
    cards: {
      marginBottom: theme.spacing(15),
    },
    pink: {
      background: theme.palette.primary.main,
      color: "#fff",
    },
    whiteButton: {
      backgroundColor: "#fff",
      color: theme.palette.primary.main,
      "&:hover": {
        color: "#fff !important",
      },
    },
    link: {
      textDecoration: "none",
      color: "#fff",
    },
  })
);

const cards = [
  {
    id: 1,
    image: bookIcon,
    title: 'Knjiga "Trudna"',
    description: "Tvoja saveznica u idućih 12 mjeseci",
    link: "https://www.roda.hr/udruga/projekti/edukacija-za-pozitivnu-trudnocu-porod-i-babinje/procitaj-knjigu-trudna-tvoja-saveznica-u-iducih-12-mjeseci.html",
  },
  {
    id: 2,
    image: mobileIcon,
    title: "Expecting",
    description: "Mobilna aplikacija Expecting za trudnice i njihove partnere",
    link: "https://www.roda.hr/udruga/projekti/edukacija-za-pozitivnu-trudnocu-porod-i-babinje/expecting-vodic-kroz-trudnocu-porod-i-roditeljstvo-rodina-mobilna-aplikacija.html",
  },
  {
    id: 3,
    image: websiteIcon,
    title: "RODA",
    description:
      "Roditelji u Akciji - portal o porodu i rodilištima u Hrvatskoj",
    link: "https://rodilista.roda.hr/",
  },
  {
    id: 4,
    image: homeIcon,
    title: "Porod kod kuće u Hrvatskoj",
    description: "Čak i ako rađate u rodilištu, dobro je biti upućen",
    link: "https://www.roda.hr/portal/porod/kako-radamo/porod-kod-kuce-u-hrvatskoj.html",
  },
];

export default function MoreInfo() {
  const classes = useStyles();

  return (
    <>
      <Container maxWidth="sm" className={classes.root}>
        <Typography variant="h3" className={classes.heading}>
          Saznajte više o svojim
          <span className={classes.accent}> pravima</span>
        </Typography>
        <Typography className={classes.subheading}>
          Niste sigurni što je uopće plan poroda i od čega se sastoji? Želite
          saznati više informacija o trudnoći, porodu i babinju?
        </Typography>
        <Typography className={classes.subheading}>
          Uvijek je dobro raspitati se o mogućnostima na redovnim pregledima kod
            ginekologa i u bolnici, a pripremile smo vam i
          <span className={classes.accent}> materijale</span> koji vam mogu
          pomoći:
        </Typography>
      </Container>

      <Container className={classes.cards}>
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          {cards.map((card) => (
            <Grid item lg={3} md={6} sm={6} xs={12}>
              <Card className={card.id == 3 ? classes.pink : ""}>
                <img
                  src={card.image}
                  alt="plan poroda"
                  style={{ width: "4rem" }}
                />
                <CardContent>
                  <Typography gutterBottom variant="body2" component="h2">
                    {card.title}
                  </Typography>
                  <Typography variant="body1">{card.description}</Typography>
                </CardContent>
                <CardActions>
                  <a className={classes.link} href={card.link} target="_blank">
                    <Button className={card.id == 3 ? classes.whiteButton : ""}>
                      Više
                    </Button>
                  </a>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
}
